<template>
  <div class="station">
    <div
      class="station_top"
      :style="{ background: showStation(item.action).color }"
    >
      {{ showStation(item.action).name }}
    </div>
    <div class="station_text">
      <span>{{ item.address.split('_')[0] }}</span>
      <div class="btn">
        <p @click="prev(item)">前移</p>
        <p @click="next(item)">后移</p>
        <p @click="del">删除</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["station"],
  data() {
    return {
      openForm: false,
      item: {
        name: "aaa",
        x: 113,
        y: 22,
        radius: 50,
        address: "guandddsdg",
      },
      stationFlag: {
        提货: {
          color: "#1e94d8",
          name: "提货",
        },
        卸货: {
          color: "#15cb56",
          name: "卸货",
        },
        途经: {
          color: "#fa5058",
          name: "途经",
        },
      },
    };
  },
  methods: {
    prev(v) {
      this.$emit("prev");
    },
    next(v) {
      this.$emit("next");
    },
    del(v) {
      this.$emit("del");
    },
    showStation(v) {
      var m = this.stationFlag;
      var obj = {
        color: "#dd48f3",
        name: v,
      };
      for (const i in m) {
        if (i == v) {
          obj = m[i];
        }
      }
      return obj;
    },
  },
  mounted() {
    this.item = this.station;
  },
  watch: {
    station(v) {
      this.item = v;
    },
  },
};
</script>
<style>
.station {
  margin-right: auto;
  text-align: center;
}
.station:last-child {
  margin-right: 10px;
}
.station:first-child {
  margin-left: 10px;
}
/* .station:last-child .station_top {
  margin-right: 0px;
  background: #0ec90e;
  color: #fff;
  border: solid 1px #15de15;
}
.station:first-child .station_top {
  margin-right: 0px;
  background: #ee3636;
  color: #fff;
  border: solid 1px #dd4848;
} */
.station_top {
  height: 20px;
  border: solid 1px #ffffff;
  color: #fff;
  background: #17d02d;
  border-radius: 10px;
  text-align: center;
  margin-bottom: 4px;
  line-height: 20px;
  font-size: 12px;
  padding: 0 4px;
}
.end {
  background: #0ec90e;
  color: #fff;
  border: solid 1px #15de15;
}
.start {
  background: #0ec90e;
  color: #fff;
  border: solid 1px #15de15;
}
.station_text {
  position: relative;
}
.station_text span {
  line-height: 20px;
  width: 20px;
  height: 90px;
  writing-mode: tb-rl;
  line-height: 20px;
  overflow: hidden;
  text-align: left;
}
.station_text span.station_type {
  background: #38a2e3;
  height: auto;
  vertical-align: top;
  color: #fff;
  padding: 10px 0;
  width: auto;
}
.station_text:hover {
  background: #dbe4ff;
}
.station_text .btn {
  display: none;
  position: absolute;
  right: -30px;
  top: 0;
  width: 30px;
  padding-left: 6px;
}
.station_text:hover .btn {
  display: block;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/wuliu/fahuo/station.vue